export interface IAddMemberRequest {
    FirstName: string;
    LastName: string;

    Email: string;
    Password: string;

    Company: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;

    Phone1: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;


}

export class AddMemberRequest implements IAddMemberRequest {
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    Company: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Phone1: string;
    Phone2: string;
    Fax: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

}


